module.exports = __webpack_public_path__ + "static/media/delivery.22b42dd9.png";